import React from "react";
import AnimationRevealPage from "../../../../helpers/AnimationRevealPage.js";
import tw from "twin.macro";
import Header from "../../../../Components/headers/PageHeader";
import MainFeature1 from "../../../../Components/Features/TwoColWithButton.js";
import Features from "../../../../Components/Features/ThreeColumnPages";
import {
  FaVideo,
  FaEye,
  FaRocket,
  FaMobileAlt,
  FaStar,
  FaBullhorn,
} from "react-icons/fa";

// Styled Components
const Subheading = tw.span`uppercase tracking-wider text-sm`;
const Heading = tw.h1`text-2xl md:text-4xl lg:text-5xl font-bold`;
const Description = tw.p`text-base md:text-lg lg:text-xl`;

export const CommercialAdVideoProductionInAlBarsha = () => {
  return (
    <AnimationRevealPage>
      {/* Header Section */}
      <Header from="Commercial Ad Video Production in Al Barsha" />

      {/* Hero Section */}
      <MainFeature1
        subheading={<Subheading>Amplify Your Brand</Subheading>}
        heading={
          <Heading>
            Professional{" "}
            <span tw="text-primary-500">Commercial Ad Video Production</span> in
            Al Barsha
          </Heading>
        }
        description={
          <Description>
            At MilaajBrandset, our commercial ad video production services in
            **Al Barsha** create high-impact, cinematic ads that drive brand
            visibility and conversions. From TV commercials to social media
            campaigns, we craft engaging videos that resonate with your audience
            and elevate your brand.
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1567593810070-7a3d471af022?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Professional commercial filming
          "https://images.unsplash.com/photo-1559028012-481c04fa702d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2672&q=80", // Business video production
          "https://images.unsplash.com/photo-1533228876829-65c94e7b5025?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial-quality filming
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Create Your Ad"
        buttonRounded={true}
        textOnLeft={false}
      />

      {/* Key Benefits Section */}
      <Features
        subheading={<Subheading>Why Choose Us?</Subheading>}
        heading="Expert Commercial Ad Production in Al Barsha"
        description="We deliver ads that captivate and convert."
        cards={[
          {
            icon: <FaBullhorn color="#ff5464" size={40} />,
            title: "High-Impact Ads",
            description:
              "Cinematic visuals that grab attention and drive action.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Engaging Storytelling",
            description:
              "Compelling narratives that connect with your audience.",
          },
          {
            icon: <FaRocket color="#ff5464" size={40} />,
            title: "Fast Turnaround",
            description: "Quick delivery to meet campaign deadlines.",
          },
          {
            icon: <FaMobileAlt color="#ff5464" size={40} />,
            title: "Multi-Platform Ready",
            description: "Optimized for TV, social media, and websites.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Trusted Expertise",
            description: "Al Barsha’s choice for commercial video production.",
          },
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Full-Service Production",
            description: "From concept to final edit, we handle it all.",
          },
        ]}
      />

      {/* Our Process Section */}
      <MainFeature1
        subheading={<Subheading>How We Work</Subheading>}
        heading="Our Commercial Ad Production Process"
        description={
          <Description>
            We create impactful commercial ads through a streamlined, creative
            process:
            <ul tw="mt-4 list-disc pl-6">
              <li>
                Consultation: Align with your brand’s goals and target audience.
              </li>
              <li>
                Concept Development: Craft a compelling script or storyboard.
              </li>
              <li>Pre-Production: Plan logistics, casting, and locations.</li>
              <li>
                Filming: Capture high-quality footage with professional
                equipment.
              </li>
              <li>
                Post-Production: Edit with effects, music, and platform-specific
                optimizations.
              </li>
              <li>Delivery: Provide a polished ad ready for your campaign.</li>
            </ul>
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1504465039542-a4622982ad53?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial storyboarding
          "https://images.unsplash.com/photo-1487958449943-2429e8be8625?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Professional video shoot
          "https://images.unsplash.com/photo-1502685104226-ee32379fefbe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial editing process
        ]}
        widths={["60%", "55%", "70%"]}
        heights={["60%", "45%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "right: 30%; top: 10%;",
          "left: 35%; bottom: 20%;",
          "right: 32%; bottom: 10%;",
        ]}
        primaryButtonText="Learn More"
        buttonRounded={true}
        textOnLeft={true}
      />

      {/* Success Stories Section */}
      <Features
        subheading={<Subheading>Success Stories</Subheading>}
        heading="Commercial Ad Wins in Al Barsha"
        description="Our commercial ads have driven brand success in Al Barsha."
        cards={[
          {
            icon: <FaVideo color="#ff5464" size={40} />,
            title: "Viral Campaign",
            description:
              "Produced a social media ad that gained massive traction.",
          },
          {
            icon: <FaEye color="#ff5464" size={40} />,
            title: "Increased Sales",
            description: "Created a TV commercial that boosted product demand.",
          },
          {
            icon: <FaStar color="#ff5464" size={40} />,
            title: "Client Acclaim",
            description: "97% satisfaction from ad production clients.",
          },
        ]}
      />

      {/* Call-to-Action Section */}
      <MainFeature1
        subheading={<Subheading>Ready to Boost Your Brand?</Subheading>}
        heading="Commercial Ad Video Production in Al Barsha"
        description={
          <Description>
            Partner with MilaajBrandset for professional commercial ad video
            production in Al Barsha. Create high-impact, engaging ads that
            elevate your brand and drive results—contact us today!
          </Description>
        }
        imageSrcs={[
          "https://images.unsplash.com/photo-1577017040065-650ee4d43339?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Dubai business district
          "https://images.unsplash.com/photo-1553877522-43269d4ea984?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2670&q=80", // Commercial filming equipment
          "https://images.unsplash.com/photo-1511512578047-dfb367046420?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2671&q=80", // Professional production team
        ]}
        widths={["55%", "60%", "70%"]}
        heights={["45%", "60%", "35%"]}
        imageColumnStyle="height: 400px;"
        imageStyle="width: 45%; height: 60%;"
        imagePositions={[
          "left: 35%; top: 20%;",
          "right: 30%; top: 10%;",
          "left: 32%; bottom: 20%;",
        ]}
        primaryButtonText="Contact Us Now"
        buttonRounded={true}
        textOnLeft={false}
      />
    </AnimationRevealPage>
  );
};
